import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import settings from "settings"
import currentUser from "helpers/currentUser"
import calculateSectionHealth from "logic/sectionHealth"

class SectionInfoWindow extends Component {
	constructor(props) {
		super(props)
		this.state = {
			id: "",
			property: "",
			section: "",
			neighborhoods: "",
			lotTypes: "",
			sold: [],
			available: [],
			sectionObj: "",
			totalLots: [],
			devLots: [],
			holdLots: [],
			models: [],
			takedowns: {},
			specsuc: {},
			buyersuc: {},
			specsComplete: {},
			buyersComplete: {},
			homesClosed: {},
			user: currentUser(),
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.section !== prevProps.section) {
			this.buildData()
		}
	}

	buildData = () => {
		let health = calculateSectionHealth(this.props.props)
		let ret = {}
		ret.id = this.props.section.id
		let sectionHealth = _.find(health, { section_id: ret.id })
		ret.health = null
		if (sectionHealth) ret.health = sectionHealth
		try {
			let totalLots = []
			let sold = []
			let available = []
			let neighborhoods = ""
			let lotTypes = ""
			let section = _.find(this.props.payload.public.sections, { id: ret.id })
			totalLots = _.filter(this.props.payload.exec.lots, { section_id: ret.id })
			let property = _.find(this.props.payload.public.properties, { id: section.property })
			ret.devLots = _.filter(totalLots, (v) => !v.takedown_date)
			ret.holdLots = _.filter(totalLots, (v) => !v.takedown_date && !v.builder)
			ret.models = _.filter(totalLots, (v) => v.model == 1)
			ret.property = property.name
			ret.section = section.name
			ret.sectionObj = section
			ret.totalLots = totalLots
			ret.takedowns = {}
			ret.specsuc = {}
			ret.buyersuc = {}
			ret.specsComplete = {}
			ret.buyersComplete = {}
			ret.homesClosed = {}
			ret.dirtContracts = {}
			ret.contractsNoTakedown = {}
			let neighborhood = _.find(this.props.payload.public.neighborhoods, { id: section.neighborhood })
			ret.neighborhood = neighborhood ? neighborhood.name : ""
			/* if (section && section.neighborhoods && section.neighborhoods.length > 0) {
				_.forEach(section.neighborhoods, (v) => {
					let neighborhood = _.find(this.props.payload.public.neighborhoods, { id: v })
					neighborhoods += neighborhood.name + ", "
				})
				ret.neighborhoods = neighborhoods.substring(0, neighborhoods.length - 2)
			} */

			let lotsInSection = _.filter(this.props.payload.exec.lots, { section_id: ret.id })
			let types = []
			_.forEach(lotsInSection, (v) => {
				types.push(v.lot_type)
				if (!_.has(ret.takedowns, v.builder)) {
					_.set(ret.takedowns, v.builder, [])
				}
				if (!_.has(ret.specsuc, v.builder)) {
					_.set(ret.specsuc, v.builder, [])
				}
				if (!_.has(ret.buyersuc, v.builder)) {
					_.set(ret.buyersuc, v.builder, [])
				}
				if (!_.has(ret.specsComplete, v.builder)) {
					_.set(ret.specsComplete, v.builder, [])
				}
				if (!_.has(ret.buyersComplete, v.builder)) {
					_.set(ret.buyersComplete, v.builder, [])
				}
				if (!_.has(ret.homesClosed, v.builder)) {
					_.set(ret.homesClosed, v.builder, [])
				}
				if (!_.has(ret.dirtContracts, v.builder)) {
					_.set(ret.dirtContracts, v.builder, [])
				}
				if (!_.has(ret.contractsNoTakedown, v.builder)) {
					_.set(ret.contractsNoTakedown, v.builder, [])
				}

				// takedowns
				if (v.takedown_date) {
					ret.takedowns[v.builder].push(v)
				}

				// specs uc
				if (v.start_date && !v.complete_date && !v.closing_date && !v.sale_id) {
					ret.specsuc[v.builder].push(v)
				}

				if (v.buyer_id && !v.complete_date && v.start_date) {
					ret.buyersuc[v.builder].push(v)
				}

				if (v.complete_date && !v.buyer_id && !v.closing_date) {
					ret.specsComplete[v.builder].push(v)
				}

				if (v.buyer_id && v.complete_date && !v.closing_date) {
					ret.buyersComplete[v.builder].push(v)
				}

				if (v.closing_date) {
					ret.homesClosed[v.builder].push(v)
				}

				if (v.takedown_date && v.sale_id && !v.start_date && v.builder) {
					ret.dirtContracts[v.builder].push(v)
				}

				if (!v.takedown_date && v.sale_id && !v.start_date && v.builder) {
					ret.contractsNoTakedown[v.builder].push(v)
				}
			})
			types = _.uniq(types)
			_.forEach(types, (v) => {
				let type = _.find(this.props.payload.public.lot_types, { id: v })
				if (type) {
					lotTypes += `${type.name}, `
				}
			})
			ret.lotTypes = lotTypes.substring(0, lotTypes.length - 2)

			_.forEach(totalLots, (v) => {
				if (v.closing_date) {
					sold.push(v)
				} else {
					available.push(v)
				}
			})

			ret.sold = sold
			ret.available = available
			this.setState(ret)
		} catch (err) {
			console.log(err)
		}
	}

	buildObjs = (type) => {
		return _.map(this.state[type], (v, k) => {
			let id = parseInt(k)
			let b = _.find(this.props.payload.public.builders, { id: id })
			if (!b) {
				return
			}
			if (typeof v !== "object") {
				return (
					<li key={k}>
						<strong>{b.name}</strong> : 0
					</li>
				)
			}
			return (
				<li key={k}>
					<strong>{b.name}</strong>: {v.length}
				</li>
			)
		})
	}

	render() {
		let viewPlat
		if (this.state.sectionObj.plat_file && this.state.user.group == settings.groups.dev) {
			viewPlat = (
				<tr>
					<td>Plat File</td>
					<td>
						<a href={`${settings.s3}${this.state.sectionObj.plat_file}`} target="_blank">
							View Plat
						</a>
					</td>
				</tr>
			)
		}
		let superRows
		let superFields

		if (this.state.user.group == settings.groups.dev) {
			superRows = (
				<>
					<tr>
						<td>Lot Types</td>
						<td>{this.state.lotTypes}</td>
					</tr>
					<tr>
						<td>Platted Lots</td>
						<td>{this.state.totalLots.length}</td>
					</tr>
					<tr>
						<td>Developer Owned</td>
						<td>{this.state.devLots.length}</td>
					</tr>
					<tr>
						<td>Hold Lots</td>
						<td>{this.state.holdLots.length}</td>
					</tr>
					<tr>
						<td>Model Homes</td>
						<td>{this.state.models.length}</td>
					</tr>
					{this.state.health && (
						<>
							<tr>
								<td>Sales Pace (12 Mo)</td>
								<td>{this.state.health?.avg_monthly_sales_12}</td>
							</tr>
							<tr>
								<td>Rem. Supply (12 Mo)</td>
								<td>{this.state.health?.remaining_months_12}</td>
							</tr>
							<tr>
								<td>Sales Pace (4 Mo)</td>
								<td>{this.state.health?.avg_monthly_sales_4}</td>
							</tr>
							<tr>
								<td>Rem. Supply (4 Mo)</td>
								<td>{this.state.health?.remaining_months_4}</td>
							</tr>
						</>
					)}
				</>
			)
			superFields = (
				<>
					<div className="legend__coloredCont legend__coloredCont--takedown">
						<p>Takedowns</p>
						<ul className="legend__coloredList">{this.buildObjs("takedowns")}</ul>
					</div>
					<div className="legend__coloredCont legend__coloredCont--white">
						<p>Contract with No Takedown</p>
						<ul className="legend__coloredList">{this.buildObjs("contractsNoTakedown")}</ul>
					</div>
					<div className="legend__coloredCont legend__coloredCont--takedown">
						<p>Dirt Contracts</p>
						<ul className="legend__coloredList">{this.buildObjs("dirtContracts")}</ul>
					</div>
					<div className="legend__coloredCont legend__coloredCont--start">
						<p>Specs Under Construction</p>
						<ul className="legend__coloredList">{this.buildObjs("specsuc")}</ul>
					</div>
					<div className="legend__coloredCont legend__coloredCont--start">
						<p>Buyers Under Construction</p>
						<ul className="legend__coloredList">{this.buildObjs("buyersuc")}</ul>
					</div>
					<div className="legend__coloredCont legend__coloredCont--complete">
						<p>Specs Complete</p>
						<ul className="legend__coloredList">{this.buildObjs("specsComplete")}</ul>
					</div>
					<div className="legend__coloredCont legend__coloredCont--complete">
						<p>Buyers Complete</p>
						<ul className="legend__coloredList">{this.buildObjs("buyersComplete")}</ul>
					</div>
					<div className="legend__coloredCont legend__coloredCont--closed">
						<p>Homes Closed to Homebuyer</p>
						<ul className="legend__coloredList">{this.buildObjs("homesClosed")}</ul>
					</div>
				</>
			)
		}
		return (
			<div className="heatmap__sectionInfo">
				<h4 className="lotStatus__legendTitle">{this.state.property}</h4>
				<table className="lotStatus__legendTable">
					<tbody>
						<tr>
							<td>Section Code</td>
							<td>{this.state.section}</td>
						</tr>
						{viewPlat}
						<tr>
							<td>Neighborhood Name</td>
							<td>{this.state.neighborhood}</td>
						</tr>
						{superRows}
					</tbody>
				</table>
				{superFields}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SectionInfoWindow)
